// extracted by mini-css-extract-plugin
module.exports = {"logo":"shop_logo__RcAqL","heroHeader":"shop_heroHeader__NVf3B","products":"shop_products__3iRPd"};